import React from 'react';
import GlobalProps from '../../../../components/globalProps';
import { TextField } from '../../../../components/Form/TextField/TextField';
import { Label } from '../../../../components/Form/Label/Label';
import { Select } from '../../../../components/Form/Select/Select';
import { Venue, patchVenue, createVenue } from '../../../../model/venue';
import { Country } from '../../../../model/country';
import './VenueForm.css';
import { t } from '../../../../locales/translate';
import { Form, useChanges } from '../../../../components/Form/Form';
import { ModalController } from '../../../../components/Modal/ControlledModal';
import { uniqBy } from 'lodash';
import { Stack } from '../../../../components/Stack/Stack';
import { Spacer } from '../../../../components/Spacer/Spacer';

interface Props extends GlobalProps {
  controller: ModalController<Venue>;
  countries: Country[];
  onSuccess?: () => void;
}

export function VenueForm({ controller, countries, onSuccess }: Props): JSX.Element {
  const [, setChanges, model] = useChanges<Venue>(controller.model || {});
  const filteredCountries = uniqBy(countries, 'countryCode');

  async function handleOnSubmit(): Promise<void> {
    if (model && model.id) {
      await patchVenue(model);
    } else {
      await createVenue(model);
    }
    onSuccess?.();
    controller.close();
  }

  return (
    <Form model={model} onInput={setChanges} className="venue-layout-modal__form">
      {(form) => {
        controller.configure({
          canSubmit: form.valid,
          onSubmit: handleOnSubmit,
        });
        return (
          <Stack>
            <TextField name="name" label={t.model.user.name} required />
            <TextField name="address.address" label={t.model.address.street} required />
            <TextField name="address.address2" label={t.model.address.additionalStreet} />
            <TextField name="address.postCode" label={t.model.address.postCode} required />
            <TextField name="address.city" label={t.model.address.city} required />
            <Select
              name="address.countryCode"
              label={t.model.address.country}
              allowEmpty
              required
              options={filteredCountries.map((c) => ({
                label: c.name,
                value: c.countryCode,
              }))}
            />
            <Spacer size="none" />
            <Label title={t.model.user.contactDetails} />
            <TextField name="address.firstName" label={t.model.user.name} />
            <TextField name="address.phone" label={t.model.user.phone} />
            <TextField name="address.email" type="email" label={t.model.user.email} />
          </Stack>
        );
      }}
    </Form>
  );
}
